import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from "sonner";
/** The toast area; show toasts with `toast()` / `toast.error()` from this package. */
export function Toaster(props) {
    return _jsx(Sonner, { position: "top-center", richColors: true, closeButton: true, ...props });
}
export { toast } from "sonner";
//# sourceMappingURL=toaster.js.map